import { Bundle } from '@spiffcommerce/core'
import { useAppContext } from '../context/AppContext'

export const tranformPendantProducts = async (bundle: Bundle, isOnBodyPreview: boolean) => {
  const workflowExperiences = bundle.getWorkflowExperiences()
  const pendantWorkflowExperiences = workflowExperiences.slice(1)
  await Promise.all([
    pendantWorkflowExperiences.map((workflowExperience) => {
      if (isOnBodyPreview) {
        return bundle.activateWorkflowExperienceTransform(workflowExperience, 'default-position')
      } else {
        return bundle.activateWorkflowExperienceTransform(workflowExperience, 'body-position')
      }
    })
  ])
}

export const useOnbodyPreview = () => {
  const { onBodyPreviewStep, isOnBodyPreview, setIsOnBodyPreview } = useAppContext()

  const toggleOnBodyPreview = async (bundle: Bundle) => {
    const variants = onBodyPreviewStep?.getAvailableVariants()
    setIsOnBodyPreview(!isOnBodyPreview)
    await onBodyPreviewStep?.selectVariant(isOnBodyPreview ? variants![0] : variants![1])
    onBodyPreviewStep?.executeAnimations()
    await tranformPendantProducts(bundle, isOnBodyPreview)
  }

  return {
    toggleOnBodyPreview,
    onBodyPreviewStep,
    isOnBodyPreview
  }
}
